// legal agreements
const AMOUS_TMS_PRIVACY_POLICY = 'https://amoustms.com/privacy_policy';
const AMOUS_TMS_TERMS_AND_CONDITIONS = 'https://amoustms.com/terms_and_conditions';

// images
const DEFAULT_IMAGE_URL = 'https://amous-front-dev.s3.amazonaws.com/';
const AMOUS_TMS_LOGO_ROUNDED_URL = `${DEFAULT_IMAGE_URL}newAmousLogo.svg`;
const AUTH_BACKGROUND_URL = `${DEFAULT_IMAGE_URL}white-background-new.jpg`;

// pages
const AMOUS_TMS_LOGIN = 'https://amoustms.com/login';
const AMOUS_TMS_WEBSITE = 'https://amousinternational.com/';

// social media
const AMOUS_TMS_SOCIAL_MEDIA_INSTAGRAM = 'https://www.instagram.com/amous_tms/?hl=en';
const AMOUS_TMS_SOCIAL_MEDIA_FACEBOOK = 'https://www.facebook.com/amousinternational/';
const AMOUS_TMS_SOCIAL_MEDIA_YOUTUBE = 'http://www.youtube.com/channel/UCRXHaNFn2XpHCFGCDI-4aDw';
const AMOUS_TMS_SOCIAL_MEDIA_LINKEDIN = 'https://www.linkedin.com/company/amous-international-tms';

export {
  AMOUS_TMS_LOGIN,
  AMOUS_TMS_WEBSITE,
  AUTH_BACKGROUND_URL,
  AMOUS_TMS_PRIVACY_POLICY,
  AMOUS_TMS_LOGO_ROUNDED_URL,
  AMOUS_TMS_SOCIAL_MEDIA_YOUTUBE,
  AMOUS_TMS_TERMS_AND_CONDITIONS,
  AMOUS_TMS_SOCIAL_MEDIA_FACEBOOK,
  AMOUS_TMS_SOCIAL_MEDIA_LINKEDIN,
  AMOUS_TMS_SOCIAL_MEDIA_INSTAGRAM,
};
